<div class="text">
  <ng-content></ng-content>
</div>
<div class="button">
  <ng-content select="itl-button"></ng-content>
  <ng-content select="itl-icon-button"></ng-content>
</div>
